import { FacilityCompleteCard } from "routes/schedule/my-schedules/my-group-types/facility/facilityCompleteCard"
import { useBoundContext } from "lib/@components/binding/use-bound-context"

export function FacilityDisplay() {
    const { parentItem } = useBoundContext()
    const facility = parentItem.data
    return <FacilityCompleteCard facility={facility} />
}
